import {
  getExternalDatabaseConnection as publicGetExternalDatabaseConnection,
  listExternalDatabaseConnections as publicListExternalDatabaseConnections,
  createExternalDatabaseConnection as publicCreateExternalDatabaseConnection,
  updateExternalDatabaseConnection as publicUpdateExternalDatabaseConnection,
  deleteExternalDatabaseConnection as publicDeleteExternalDatabaseConnection,
} from './data-v1-external-database-connection-external-database-connections.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getExternalDatabaseConnection: MaybeContext<
  BuildRESTFunction<typeof publicGetExternalDatabaseConnection> &
    typeof publicGetExternalDatabaseConnection
> = /*#__PURE__*/ createRESTModule(publicGetExternalDatabaseConnection);
export const listExternalDatabaseConnections: MaybeContext<
  BuildRESTFunction<typeof publicListExternalDatabaseConnections> &
    typeof publicListExternalDatabaseConnections
> = /*#__PURE__*/ createRESTModule(publicListExternalDatabaseConnections);
export const createExternalDatabaseConnection: MaybeContext<
  BuildRESTFunction<typeof publicCreateExternalDatabaseConnection> &
    typeof publicCreateExternalDatabaseConnection
> = /*#__PURE__*/ createRESTModule(publicCreateExternalDatabaseConnection);
export const updateExternalDatabaseConnection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExternalDatabaseConnection> &
    typeof publicUpdateExternalDatabaseConnection
> = /*#__PURE__*/ createRESTModule(publicUpdateExternalDatabaseConnection);
export const deleteExternalDatabaseConnection: MaybeContext<
  BuildRESTFunction<typeof publicDeleteExternalDatabaseConnection> &
    typeof publicDeleteExternalDatabaseConnection
> = /*#__PURE__*/ createRESTModule(publicDeleteExternalDatabaseConnection);

export {
  CauseOfFailure,
  CollectionsFound,
  FieldType,
  ProtocolVersion,
  ConnectionType,
  WebhookIdentityType,
} from './data-v1-external-database-connection-external-database-connections.universal.js';
export {
  ExternalDatabaseConnection,
  ConnectionStatus,
  Capabilities,
  GetExternalDatabaseConnectionRequest,
  GetExternalDatabaseConnectionResponse,
  ListExternalDatabaseConnectionsRequest,
  Paging,
  ListExternalDatabaseConnectionsResponse,
  PagingMetadata,
  CreateExternalDatabaseConnectionRequest,
  CreateExternalDatabaseConnectionResponse,
  UpdateExternalDatabaseConnectionRequest,
  UpdateExternalDatabaseConnectionResponse,
  DeleteExternalDatabaseConnectionRequest,
  DeleteExternalDatabaseConnectionResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListExternalDatabaseConnectionsOptions,
  UpdateExternalDatabaseConnection,
} from './data-v1-external-database-connection-external-database-connections.universal.js';
export {
  CauseOfFailureWithLiterals,
  CollectionsFoundWithLiterals,
  FieldTypeWithLiterals,
  ProtocolVersionWithLiterals,
  ConnectionTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-v1-external-database-connection-external-database-connections.universal.js';
